import { render, staticRenderFns } from "./ExpandableList.vue?vue&type=template&id=1b7bca4b&scoped=true"
import script from "./ExpandableList.vue?vue&type=script&lang=js"
export * from "./ExpandableList.vue?vue&type=script&lang=js"
import style0 from "./ExpandableList.vue?vue&type=style&index=0&id=1b7bca4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bca4b",
  null
  
)

export default component.exports